export const configuratorTranslations = {
  en: {
    home: {
      title: 'Configure your project',
      description:
        'Tell us about your project and we will help you find the best solution.',
      startButton: 'Start Configuration',
      coboworxDescription:
        'An innovative start-up based in Germany, Coboworx designs standardised robotics solutions for SMEs. We created their 3D configurator, allowing users to see the model of their solution in real time. This allows Coboworx to create a complex offer for the customer automatically using their data. We developed and deployed the web app, integrate it with CMS and CRM systems and set up tracking.'
    },
    whoWeAre: {
      title: 'your customers want more',
      description: `Every day, customers visit your website. They scroll, they explore, they imagine—but they don't buy. Why? Because they don't see exactly what they want. They don't know what's possible. And they don't have control. Instead, they send emails. They wait for quotes. And sometimes… they leave. But what if your customers could create their perfect product in real-time? No confusion. No friction. Just a seamless, intuitive experience.`
    },
    configureNow: {
      title: 'Start to configure',
      typewriterWord: ' now',
      contactUs: 'Contact us',
      description:
        'Fill out the form below and we will get back to you with a customized solution.',
      form: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
        submitButton: 'Send',
        successMessage:
          'Thank you for your message. We will get back to you soon.',
        errorMessage:
          'Sorry, there was an error sending your message. Please try again.'
      }
    },
    challenges: {
      mainTitle: "Why Standard CPQ Tools Aren't Enough",
      challenges: [
        {
          title: 'The Hidden Cost of Manual Processes',
          desc: 'Many companies rely on outdated, manual workflows for product customization, quoting, and sales. This often leads to inefficiencies, errors, and slower response times, leaving customers frustrated and businesses at a disadvantage.',
          challenges: [
            'Time-consuming back-and-forth communication with customers.',
            'Frequent errors in quotes due to manual processes.',
            'Limited scalability as your business grows.'
          ],
          solutions: [
            'A custom configurator automates these processes, reducing errors and freeing up your team to focus on high-value tasks.',
            'Customers can configure products themselves, reducing response times and improving satisfaction.'
          ]
        },
        {
          title: 'Struggling to Keep Up with Customer Expectations?',
          desc: "Today's customers expect quick, seamless, and personalized buying experiences. Without a configurator, it's challenging to meet these demands and stand out in a competitive market.",
          challenges: [
            'Customers want real-time customization options and visualizations.',
            'The inability to showcase product variations effectively can lead to lost sales.',
            'Competitors who offer configurators already have an edge.'
          ],
          solutions: [
            'A configurator allows customers to personalize and visualize products in real time.',
            'By providing a professional and modern experience, you gain a competitive edge and build trust with your customers.'
          ]
        },
        {
          title: 'Complex Products, Simple Solutions',
          desc: 'If your products have multiple variations, configurations, or options, explaining them manually can overwhelm both your team and your customers.',
          challenges: [
            'Sales teams struggle to explain complex product options without a visual tool.',
            'Customers feel confused and unsure, leading to lost opportunities.',
            'Scaling becomes difficult without a streamlined process.'
          ],
          solutions: [
            'A configurator simplifies even the most complex products by breaking them down into easy-to-understand options.',
            'Your sales team can rely on a powerful tool that eliminates confusion and boosts confidence for customers.'
          ]
        }
      ],
      cards: [
        {
          title: "Generic CPQ Solutions Don't Understand Your Business",
          desc: "Sure, CPQ tools handle pricing. But they don't create experiences. They don't make buying exciting. They don't help your brand stand out."
        },
        {
          title: "Product Changes Shouldn't Slow You Down",
          desc: "Your products evolve. Your configurator should, too. With a fully adaptable system, you'll never have to rely on developers for small updates again."
        },
        {
          title: 'Powerful CPQ Meets Custom UX: The Best of Both Worlds',
          desc: "We combine advanced configurator technology from leading CPQ platforms with our expertise in user experience and seamless integration. The result? A configurator that's not only powerful—but feels effortless."
        }
      ],
      sectionTitles: {
        challenges: 'Challenges:',
        solutions: 'Our Solution:'
      }
    },
    howItWorks: {
      title: 'how it works',
      subtitle: 'Seamless for your team. Effortless for your customers.',
      designPhase: 'Design Phase',
      developmentPhase: 'Development Phase',
      designPhases: [
        {
          id: '01',
          title: 'Client interview',
          description:
            "To gain a better understanding of the client's business goals, and expectations, we need to conduct initial interviews. The interview typically lasts for about 60 during which we have option to get to know your goals."
        },
        {
          id: '02',
          title: 'First projects',
          description:
            "Our team will use interview insights to create two designs for further discussions. We'll consider all relevant factors, including user needs, industry trends, and design best practices."
        },
        {
          id: '03',
          title: 'Feedback loops',
          description:
            "The final design includes design mockups for desktops, tablets, and phones, along with detailed instructions for developers to implement the design team's vision accurately."
        },
        {
          id: '04',
          title: 'Final projects',
          description:
            'To ensure client satisfaction, we offer two rounds of revisions to refine the project to meet your needs.'
        }
      ],
      developmentPhases: [
        {
          id: '01',
          title: 'Technical assesment',
          description:
            'In this phase we learn about your existing technical solutions and environment in which will live configurator.'
        },
        {
          id: '02',
          title: 'Development',
          description:
            'Our developers build the configuration, coding and integrating features, ensuring alignment with project requirements. We update the client regularly with progress reports and demos to confirm expectations.'
        },
        {
          id: '03',
          title: 'Testing',
          description:
            'QA team chek if the solution is free of bugs, responsive and consistent across platforms. Additionally, we establish open communication channels with you to address concerns and take feedback.'
        },
        {
          id: '04',
          title: 'Optionals',
          description:
            'We also provide services as maintanance, CRM inntegration, Ad-hoc Consultancy or Project Managmenet. This step depends on invidual customer needs.'
        },
        {
          id: '05',
          title: 'You Own It, 100%',
          description:
            'No hidden fees. No subscriptions. The configurator is yours, forever.'
        }
      ]
    },
    titleCard: {
      mainText:
        'Transform your product customization with our expert solution for custom',
      typewriterWord: ' configurators',
      discoverSolutions: 'Discover solutions',
      howItWorks: 'How it works',
      items: [
        {
          title: [
            { text: 'Cost', color: 'green' },
            { text: '-', color: 'gray' },
            { text: 'Effective', color: 'gray' }
          ],
          description:
            'Reduce overhead and manual work by automating complex configurations, saving both time and resources.'
        },
        {
          title: [
            { text: 'Ease of ', color: 'gray' },
            { text: 'Updates', color: 'green' },
            { text: ' and ', color: 'gray' },
            { text: 'Adaptability', color: 'green' }
          ],
          description:
            'Product changes in your EMS are automatically reflected in the custom frontend—no manual updates or developer intervention needed.'
        },
        {
          title: [
            { text: 'Superior ', color: 'gray' },
            { text: 'User', color: 'green' },
            { text: ' Experience ', color: 'green' },
            { text: '(UX)', color: 'gray' }
          ],
          description:
            'Deliver an intuitive, visually engaging experience that keeps customers engaged and confident in their choices.'
        },
        {
          title: [
            { text: 'Brand Alignment', color: 'gray' },
            { text: ' and ', color: 'gray' },
            { text: 'Customization', color: 'green' }
          ],
          description:
            'Your configurator should look and feel like your brand. We create tailored designs that seamlessly match your identity.'
        },
        {
          title: [
            { text: 'Tailored', color: 'green' },
            { text: ' Solutions', color: 'gray' }
          ],
          description: `One size doesn't fit all. We build configurators that align with your specific industry needs and sales processes.`
        }
      ]
    },
    whatWeDo: {
      title: 'what we do',
      mainText: 'We help to choose technology',
      highlightedText: ' suitable to your case, ',
      subText: 'design and deliver exceptional software solutions.',
      whatWeDoPoints: [
        {
          title: 'Tech and Strategy Consulting',
          info:
            'From strategy to front and backend development,' +
            'to UX design, to data engineering, and product innovation we ' +
            'offer consultation in all areas of technology landscape.'
        },
        {
          title: 'Software Development',
          info:
            'With wide-ranging experience in Industry 4.0, customer-facing and B2B solutions, ' +
            'our core focus is on the creation of web apps and platforms based on JS technology (React, Node.js)'
        },
        {
          title: 'Cloud Engineering',
          info: 'We create and manage corporate Cloud environments, analyse and plan migrations and oversee governance processes and automation (IaaC).'
        },
        {
          title: 'Data Engineering',
          info:
            'Our services include building data pipelines for large volumes (real-time and' +
            'batch processing), development of automated data quality checks/unification and implementation of ' +
            'complex data models.'
        },
        {
          title: 'Innovation Teams',
          info: 'Our startups experienced teams deliver digitised business processes and create fully-realised digital products based on cutting edge AI technology.'
        }
      ],
      toolkit: [
        'Microsoft Azure',
        'Google Cloud',
        'Amazon WS',
        'Angular JS',
        'JS+CSS+HTML',
        'React',
        'Angular',
        'Node',
        'Python',
        'Apache Spark',
        'Github'
      ]
    },
    bottomBarItems: [
      {
        title: [
          { text: 'Cost', color: 'green' },
          { text: '-', color: 'gray' },
          { text: 'Effective', color: 'gray' }
        ],
        description:
          'Reduce overhead and manual work by automating complex configurations, saving both time and resources.'
      },
      {
        title: [
          { text: 'Ease of ', color: 'gray' },
          { text: 'Updates', color: 'green' },
          { text: ' and ', color: 'gray' },
          { text: 'Adaptability', color: 'green' }
        ],
        description:
          'Product changes in your EMS are automatically reflected in the custom frontend—no manual updates or developer intervention needed.'
      },
      {
        title: [
          { text: 'Superior ', color: 'gray' },
          { text: 'User', color: 'green' },
          { text: ' Experience ', color: 'green' },
          { text: '(UX)', color: 'gray' }
        ],
        description:
          'Deliver an intuitive, visually engaging experience that keeps customers engaged and confident in their choices.'
      },
      {
        title: [
          { text: 'Brand Alignment', color: 'gray' },
          { text: ' and ', color: 'gray' },
          { text: 'Customization', color: 'green' }
        ],
        description:
          'Your configurator should look and feel like your brand. We create tailored designs that seamlessly match your identity.'
      },
      {
        title: [
          { text: 'Tailored', color: 'green' },
          { text: ' Solutions', color: 'gray' }
        ],
        description: `One size doesn't fit all. We build configurators that align with your specific industry needs and sales processes.`
      }
    ],
    configurators: {
      tryItOut: 'Try it out',
      discoverSolutions: 'Discover solutions'
    },
    work: {
      moreWork: 'More work',
      techUsed: 'Technologies used',
      whatWeDid: 'What we did',
      projectDescription: 'Project description',
      clientReview: 'Client review',
      viewProject: 'View project',
      relatedProjects: 'Related projects'
    }
  },
  de: {
    home: {
      title: 'Konfigurieren Sie Ihr Projekt',
      description:
        'Erzählen Sie uns von Ihrem Projekt und wir helfen Ihnen, die beste Lösung zu finden.',
      startButton: 'Konfiguration starten',
      coboworxDescription:
        'Coboworx ist ein innovatives Robotik-Start-up mit Sitz in Deutschland, das standardisierte Robotiklösungen für KMU entwickelt. Wir haben ihren 3D-Konfigurator entwickelt, mit dem die Nutzer das Modell ihrer Lösung in Echtzeit sehen können. So kann Coboworx dem Kunden anhand seiner Daten automatisch ein komplexes Angebot erstellen. Wir entwickelten und implementierten die Web-App, integrierten sie in CMS- und CRM-Systeme und richteten ein Tracking ein.'
    },
    whoWeAre: {
      title: 'Deine Kunden wollen mehr',
      description: `Jeden Tag besuchen Kunden deine Website. Sie scrollen, schauen sich um,
        stellen sich vor, was möglich wäre – aber sie kaufen nicht. Warum? Weil
        sie nicht genau das sehen, was sie suchen. Weil sie nicht wissen, welche
        Optionen verfügbar sind. Stattdessen senden sie E-Mails, warten auf
        Angebote – und manchmal gehen sie einfach. Was wäre, wenn deine Kunden
        ihr perfektes Produkt in Echtzeit erstellen könnten? Ohne
        Missverständnisse. Ohne Verzögerungen. Einfach ein nahtloses, intuitives
        Erlebnis.`
    },
    configureNow: {
      title: 'Starte jetzt mit der Konfiguration',
      contactUs: 'Kontakt',
      description:
        'Füllen Sie das Formular unten aus und wir melden uns mit einer maßgeschneiderten Lösung bei Ihnen.',
      form: {
        name: 'Name',
        email: 'E-Mail',
        message: 'Nachricht',
        submitButton: 'Absenden',
        successMessage:
          'Vielen Dank für Ihre Nachricht. Wir werden uns bald bei Ihnen melden.',
        errorMessage:
          'Entschuldigung, beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
      }
    },
    challenges: {
      mainTitle: 'Warum Standard-CPQ-Tools nicht ausreichen',
      challenges: [
        {
          title: 'Die versteckten Kosten manueller Prozesse',
          desc: 'Viele Unternehmen setzen bei der Produktkonfiguration, Angebotserstellung und im Vertrieb noch auf veraltete, manuelle Abläufe. Das führt oft zu Ineffizienz, Fehlern und langen Reaktionszeiten – zum Nachteil von Kunden und Unternehmen.',
          challenges: [
            'Zeitraubende Abstimmungsschleifen mit Kunden.',
            'Häufige Fehler bei Angeboten aufgrund manueller Prozesse.',
            'Begrenzte Skalierbarkeit, wenn das Unternehmen wächst.'
          ],
          solutions: [
            'Ein maßgeschneiderter Konfigurator automatisiert diese Abläufe, minimiert Fehler und gibt deinem Team Zeit für wertschöpfende Aufgaben.',
            'Kunden können Produkte selbst konfigurieren – schneller, einfacher und genau nach ihren Vorstellungen.'
          ]
        },
        {
          title: 'Hältst du mit Kundenerwartungen mit?',
          desc: 'Kunden erwarten heute schnelle, nahtlose und personalisierte Einkaufserlebnisse. Ohne einen Konfigurator wird es schwierig, diesen Anforderungen gerecht zu werden – und sich in einem wettbewerbsintensiven Markt abzuheben. ',
          challenges: [
            'Kunden möchten Produkte in Echtzeit anpassen und visualisieren.',
            'Die fehlende Möglichkeit, Produktvarianten überzeugend darzustellen, führt zu verlorenen Verkaufschancen.',
            'Wettbewerber mit Konfiguratoren haben bereits einen Vorsprung.'
          ],
          solutions: [
            'Ein Konfigurator ermöglicht es deine Kunden, Produkte in Echtzeit anzupassen und zu visualisieren.',
            'Mit einem modernen und professionellen Erlebnis schaffst du Vertrauen, hebst dich vom Wettbewerb ab und erhöhst die Abschlussquote.'
          ]
        },
        {
          title: 'Komplexe Produkte, einfache Lösungen',
          desc: 'Wenn deine Produkte zahlreiche Varianten, Konfigurationen oder Optionen bieten, wird die manuelle Erklärung schnell zur Herausforderung – sowohl für dein Vertriebsteam als auch für deine Kunden.',
          challenges: [
            'Vertriebsteams kämpfen damit, komplexe Produktoptionen ohne visuelles Tool verständlich zu erklären.',
            'Kunden fühlen sich überfordert und unsicher – potenzielle Abschlüsse gehen verloren.',
            'Ohne klar strukturierte Prozesse wird es schwierig, das Geschäft zu skalieren.'
          ],
          solutions: [
            'Ein Konfigurator macht selbst komplexe Produkte greifbar, indem er Optionen einfach und übersichtlich darstellt.',
            'Dein Vertriebsteam erhält ein leistungsstarkes Tool, das Missverständnisse vermeidet und Kunden Vertrauen in ihre Auswahl gibt.'
          ]
        }
      ],
      cards: [
        {
          title: 'Generische CPQ-Tools verstehen Ihr Geschäft nicht',
          desc: 'Ja, CPQ-Lösungen regeln die Preisgestaltung. Aber sie schaffen keine Erlebnisse. Sie machen den Kaufprozess nicht spannend. Und sie lassen deine Marke nicht herausstechen.'
        },
        {
          title: 'Produktänderungen dürfen kein Hindernis sein',
          desc: 'Deine Produkte entwickeln sich weiter – dein Konfigurator sollte das auch. Mit einem flexiblen System musst du nicht länger für jede kleine Anpassung auf Entwickler angewiesen sein.'
        },
        {
          title:
            'Leistungsstarke CPQ-Lösungen treffen auf maßgeschneiderte UX – die perfekte Kombination',
          desc: 'Wir verbinden die Möglichkeiten führender CPQ-Technologien mit unserer Expertise in User Experience und nahtloser Integration. Das Ergebnis? Ein Konfigurator, der nicht nur leistungsstark ist, sondern sich auch mühelos bedienen lässt.'
        }
      ],
      sectionTitles: {
        challenges: 'Herausforderungen:',
        solutions: 'Unsere Lösung:'
      }
    },
    howItWorks: {
      title: `So funktioniert's`,
      subtitle: 'Einfach für dein Team. Mühelos für deine Kunden.',
      designPhase: 'Designphase',
      developmentPhase: 'Entwicklungsphase',
      designPhases: [
        {
          id: '01',
          title: 'Kundeninterview',
          description:
            'Um die Geschäftsziele und Erwartungen umfassend zu verstehen, starten wir mit einem ausführlichen Gespräch. In etwa 60 Minuten lernen wir deine Anforderungen kennen und legen die ersten Grundsteine.'
        },
        {
          id: '02',
          title: 'Erste Entwürfe',
          description:
            'Auf Basis der gewonnenen Einblicke entwickeln wir zwei Designkonzepte. Dabei berücksichtigen wir Nutzerbedürfnisse, Branchentrends und bewährte Designprinzipien.'
        },
        {
          id: '03',
          title: 'Feedback-Runden',
          description:
            'Die finalen Entwürfe beinhalten Design-Mockups für Desktop, Tablet und Smartphone sowie detaillierte Anweisungen für die Entwickler.'
        },
        {
          id: '04',
          title: 'Endgültige Designs',
          description:
            'Um sicherzustellen, dass das Ergebnis den Anforderungen entspricht, bieten wir zwei Feedback-Runden zur Finalisierung der Designs an.'
        }
      ],
      developmentPhases: [
        {
          id: '01',
          title: 'Technische Analyse',
          description:
            'Wir analysieren die bestehende IT-Umgebung und identifizieren die optimale Integration des Konfigurators.'
        },
        {
          id: '02',
          title: 'Entwicklung',
          description:
            'Unsere Entwickler setzen das Design um, integrieren Funktionen und stellen sicher, dass alles gemäß den Projektanforderungen umgesetzt wird. Sie erhalten regelmäßige Updates und Demos, um den Fortschritt zu verfolgen.'
        },
        {
          id: '03',
          title: 'Testing',
          description:
            'Unser QA-Team prüft die Lösung auf Fehlerfreiheit, Responsivität und Konsistenz über alle Plattformen hinweg. Zudem halten wir offene Kommunikationskanäle, um Feedback direkt umzusetzen.'
        },
        {
          id: '04',
          title: 'Optionale Services',
          description:
            'Zusätzlich bieten wir Leistungen wie Wartung, CRM-Integration, Ad-hoc-Beratung oder Projektmanagement an – maßgeschneidert auf deine Anforderungen.'
        },
        {
          id: '05',
          title: 'Dein Konfigurator – zu 100 %',
          description:
            'Keine versteckten Kosten. Keine Abonnements. Der Konfigurator gehört dir – für immer.'
        }
      ]
    },
    titleCard: {
      mainText:
        'Verwandle deinen Vertriebsprozess mit unseren maßgeschneiderten',
      typewriterWord: ' Konfiguratoren',
      discoverSolutions: 'Lösungen entdecken',
      howItWorks: `So funktioniert's`,
      items: [
        {
          title: [
            { text: 'Kosten', color: 'green' },
            { text: 'effizient', color: 'gray' }
          ],
          description:
            'Reduzieren Sie Aufwand und manuelle Prozesse, indem Sie komplexe Konfigurationen automatisieren – und sparen Sie so Zeit und Ressourcen.'
        },
        {
          title: [
            { text: 'Einfache ', color: 'gray' },
            { text: 'Updates', color: 'green' },
            { text: ' & ', color: 'gray' },
            { text: 'maximale Flexibilität', color: 'green' }
          ],
          description:
            'Änderungen in Ihrem EMS werden automatisch übernommen – ganz ohne manuellen Aufwand oder Entwicklerunterstützung.'
        },
        {
          title: [
            { text: 'Einzigartige ', color: 'gray' },
            { text: 'Benutzererfahrung ', color: 'green' },
            { text: '(UX)', color: 'gray' }
          ],
          description:
            'Bieten Sie ein intuitives, visuell ansprechendes Erlebnis, das Kunden begeistert und ihre Kaufentscheidung einfacher macht.'
        },
        {
          title: [
            { text: 'Markenkonformes Design', color: 'gray' },
            { text: ' & ', color: 'gray' },
            { text: 'individuelle Anpassung', color: 'green' }
          ],
          description:
            'Ihr Konfigurator sollte aussehen und funktionieren wie Ihre Marke. Wir entwickeln maßgeschneiderte Designs, die sich nahtlos in Ihre Markenidentität einfügen.'
        },
        {
          title: [
            { text: 'Individuelle ', color: 'green' },
            { text: 'Lösungen', color: 'gray' }
          ],
          description:
            'Standardlösungen reichen of nicht aus. Wir entwickeln Konfiguratoren, die passgenau auf Ihre Branchenanforderungen und Vertriebsprozesse abgestimmt sind.'
        }
      ]
    },
    whatWeDo: {
      title: 'was wir tun',
      mainText: 'Wir helfen bei der Auswahl der Technologie',
      highlightedText: 'die zu Ihrem Fall passt,',
      subText: 'entwerfen und liefern außergewöhnliche Softwarelösungen.',
      whatWeDoPoints: [
        {
          title: 'Technologie- und Strategieberatung',
          info:
            'Von der Strategie über Front- und Backend-Entwicklung,' +
            'UX-Design, Data Engineering bis hin zur Produktinnovation bieten wir ' +
            'Beratung in allen Bereichen der Technologielandschaft.'
        },
        {
          title: 'Softwareentwicklung',
          info:
            'Mit umfassender Erfahrung in Industrie 4.0, kundenorientierten und B2B-Lösungen ' +
            'liegt unser Fokus auf der Entwicklung von Web-Apps und Plattformen basierend auf JS-Technologie (React, Node.js)'
        },
        {
          title: 'Cloud Engineering',
          info: 'Wir erstellen und verwalten Unternehmens-Cloud-Umgebungen, analysieren und planen Migrationen und überwachen Governance-Prozesse und Automatisierung (IaaC).'
        },
        {
          title: 'Data Engineering',
          info:
            'Unsere Dienstleistungen umfassen den Aufbau von Datenpipelines für große Datenmengen (Echtzeit- und ' +
            'Batch-Verarbeitung), die Entwicklung automatisierter Datenqualitätsprüfungen/Vereinheitlichung und die Implementierung ' +
            'komplexer Datenmodelle.'
        },
        {
          title: 'Innovationsteams',
          info: 'Unsere erfahrenen Startup-Teams digitalisieren Geschäftsprozesse und entwickeln vollständig realisierte digitale Produkte basierend auf modernster KI-Technologie.'
        }
      ],
      toolkit: [
        'Microsoft Azure',
        'Google Cloud',
        'Amazon WS',
        'Angular JS',
        'JS+CSS+HTML',
        'React',
        'Angular',
        'Node',
        'Python',
        'Apache Spark',
        'Github'
      ]
    },
    bottomBarItems: [
      {
        title: [
          { text: 'Kosten', color: 'green' },
          { text: 'effizient', color: 'gray' }
        ],
        description:
          'Reduzieren Sie Aufwand und manuelle Prozesse, indem Sie komplexe Konfigurationen automatisieren – und sparen Sie so Zeit und Ressourcen.'
      },
      {
        title: [
          { text: 'Einfache ', color: 'gray' },
          { text: 'Updates', color: 'green' },
          { text: ' & ', color: 'gray' },
          { text: 'maximale Flexibilität', color: 'green' }
        ],
        description:
          'Änderungen in Ihrem EMS werden automatisch übernommen – ganz ohne manuellen Aufwand oder Entwicklerunterstützung.'
      },
      {
        title: [
          { text: 'Einzigartige ', color: 'gray' },
          { text: 'Benutzererfahrung ', color: 'green' },
          { text: '(UX)', color: 'gray' }
        ],
        description:
          'Bieten Sie ein intuitives, visuell ansprechendes Erlebnis, das Kunden begeistert und ihre Kaufentscheidung einfacher macht.'
      },
      {
        title: [
          { text: 'Markenkonformes Design', color: 'gray' },
          { text: ' & ', color: 'gray' },
          { text: 'individuelle Anpassung', color: 'green' }
        ],
        description:
          'Ihr Konfigurator sollte aussehen und funktionieren wie Ihre Marke. Wir entwickeln maßgeschneiderte Designs, die sich nahtlos in Ihre Markenidentität einfügen.'
      },
      {
        title: [
          { text: 'Individuelle ', color: 'green' },
          { text: 'Lösungen', color: 'gray' }
        ],
        description:
          'Standardlösungen reichen of nicht aus. Wir entwickeln Konfiguratoren, die passgenau auf Ihre Branchenanforderungen und Vertriebsprozesse abgestimmt sind.'
      }
    ],
    configurators: {
      tryItOut: 'Jetzt ausprobieren',
      discoverSolutions: 'Lösungen entdecken'
    },
    work: {
      moreWork: 'Weitere Arbeiten',
      techUsed: 'Verwendete Technologien',
      whatWeDid: 'Was wir gemacht haben',
      projectDescription: 'Projektbeschreibung',
      clientReview: 'Kundenbewertung',
      viewProject: 'Projekt ansehen',
      relatedProjects: 'Ähnliche Projekte'
    }
  }
}
